import { render } from "./App.vue?vue&type=template&id=2917aa0c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2917aa0c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__